<template>
	<div style="height: 100%;">
		<div v-if="loading" class="loading-div">
		  <Button loading shape="circle" type="primary"></Button>
		  <div>loading...</div>
		</div>
		<Card style="margin-bottom: 15px;height: 100%;">
			<div style="display: flex;justify-content: center;">
				<cForm ref="header" style="width: 550px; margin-bottom: 20px;" :grid="grid" :config="config" :fields="searchs" />
			</div>
			<CheckboxGroup v-model="checkFields">
				<div style="display: flex;margin-bottom: 10px;" v-for="(group,name) in fields">
					<div style="width: 80px;">
						{{name}}
					</div>
					<div style="flex: 1;">
						<Checkbox border v-for="(item,key) in group" style="margin-bottom: 5px;" :label="key">{{item}}</Checkbox>
					</div>
				</div>
			</CheckboxGroup>
			<div style="display: flex;justify-content: center;">
				<Button @click="getResult" type="primary" style="width: 200px;">{{$t('Forecast')}}</Button>
			</div>
			<div style="padding: 10px;text-align: center;border: 1px dotted red;margin-top: 20px;">
				<div>
					{{$t('Forecast Result')}}
				</div>
				<div style="font-size: 54px;color: red;font-weight: bold;min-height: 85px;">
					{{result || '---'}}
				</div>
			</div>
		</Card>
	</div>
</template>

<script>
	import cForm from '@/base/common/component/form.vue'
	import { getAllClient } from "@/api/user/client";
	import { getAllService } from "@/api/user/internal";
	import { getCountry } from "@/api/system/country";
	import { getSelectType, getKeysType, getGroupName } from "@/api/public";
	import { getDelivery } from "@/api/repository/deliveryPartyForecast";
	import { getAgent } from "@/api/tracker/agent";
	import { getStatus } from "@/api/tracker/status";
	import { getCompanyConfig } from "@/api/user/branch";
	import { getCity } from "@/api/system/city";
	export default {
		components:{
			cForm,
		},
		async mounted() {
			let service = (await getAllService()).data.payload
			const from_country = (await getCountry({ allow_depart: 1 })).data.payload
				.rows;
			const to_country = (await getCountry({ allow_arrive: 1 })).data.payload
				.rows;
			const city = (await getCity({ country_id: 12 })).data.payload
				.rows;
			// const options = (await getSelectType(['COD_TYPE','NEXT_STEP_TYPE','ORDERS_TYPE','OUTBOUND_SELECT_TYPE','ORDER_STATUS'])).data.payload
			// const deliver = (await getAgent({ 
			// 	agent_type: "bag",
			// 	status: "YES",
			// 	types: "DELIVERY",
			// })).data.payload.rows;
			// const status = (await getStatus()).data.payload
			// 	.rows;
			// const ownership = (await getCompanyConfig('company')).data.payload.company
			this.searchs.forEach(item=>{
				if (item.key === "from_country") item.options = from_country;
				if (item.key === "to_country") item.options = to_country;
				if (item.key === "city_id") item.options = city;
			})
			this.loading = false
		},
		methods:{
			getResult(){
				this.$refs["header"].$refs["form"].validate((valid) => {
				  if (valid) {
				    let data = Object.assign({fields:this.checkFields.join(',')},this.$refs['header'].formData)
				    console.log(data);
				    this.loading = true
				    getDelivery(data).then(res=>{
				    	console.log(res);
				    	this.loading = false
				    	if(res.data.status){
				    		this.result = res.data.payload.delivery
				    	}
				    })
				  }
				});
				
			}
		},
		data() {
			return {
				result:'',
				loading:true,
				checkFields:[],
				fields:{},
				config:{
					searchLength:30,
					hideSubmit:true,
					custom:false,
					inline:false,
					formBind:{
						labelWidth:160
					},
					colBind:{
						style:'margin-bottom:20px'
					},
					rules: {
					  from_country: [{ required: true,message: "cannot be empty",trigger: "change"},],
					  to_country: [{ required: true,message: "cannot be empty",trigger: "change"},],
					  city_id: [{ required: true,message: "cannot be empty",trigger: "change",type:'number'},],
					}
				},
				grid:[
					{
						from_country:24,
						to_country:24,
						city_id:24,
						is_SMSA:24,
						weight:24,
						cod_type:24,
					}
				],
				searchs:[
					{
						name:this.$t("allow_depart"),
						key: "from_country",
						component: "Select",
						placeholder() {
							return this.$t("allow_depart");
						},
						default:'SA',
						clearable: true,
						options: [],
						config: { label: "code", value: "code" }
					},
					{
						name:this.$t("allow_arrive"),
						key: "to_country",
						component: "Select",
						placeholder() {
							return this.$t("allow_arrive");
						},
						default:'SA',
						clearable: true,
						options: [],
						config: { label: "code", value: "code" },
						methods:{
							async "on-change"({ value, field, fields, searchForm }) {
								console.log(arguments);
								let country= field.options.find(t=>t.code === value)
								fields.forEach(async (el) => {
									if (el.key == "city_id") {
										if (country) {
											let res = (await getCity({ country_id: country.id })).data
												.payload.rows;
											el.options = res;
										} else {
											el.options = [];
										}
										searchForm[el.key] = "";
										return;
									}
								});
							},
						}
					},
					{
						name:this.$t("city_name"),
						key: "city_id",
						component: "Select",
						placeholder() {
							return this.$t("city_name");
						},
						clearable: true,
						options: [],
						config: {
							label: "title",
							value: "id",
						},
					},
					{
					  name:this.$t("whether") + "SMSA",
					  key: "is_SMSA",
					  placeholder() {
					    return  this.$t("whether") + "SMSA";
					  },
					  bind:{
						border:true
					  },
					  clearable: false,
					  default:0,
					  component: "Radio",
					  options: [
							{value:1,label:this.$t('YES')},
							{value:0,label:this.$t('NO')},
						],
					},
					{
						name:this.$t("Weigh more than") + "5",
					  key: "weight",
					  placeholder() {
					    return  this.$t("Weigh more than") + "5";
					  },
					  clearable: true,
					  component: "Radio",
					  bind:{
						  border:true
					  },
					  default:0,
					  options: [
							{value:1,label:this.$t('YES')},
							{value:0,label:this.$t('NO')},
						],
					},
					{
						name:this.$t("fangdan"),
					  key: "cod_type",
					  placeholder() {
					    return  this.$t("fangdan");
					  },
					  clearable: true,
					  component: "Radio",
					  bind:{
						  border:true
					  },
					  default:'PP',
					  options: [
							{value:"COD",label:"COD"},
							{value:"PP",label:"PP"},
						],
					},
					// {
					//   key: "awbnos",
					//   placeholder() {
					//     return this.$t("order_number");
					//   },
					//   bind: {
					//     type: "textarea",
					//     rows: 2,
					//   },
					//   component: "Input",
					// },
				],
			}
		},
	}
</script>

<style scoped>

</style>